<template>
    <div>
        <agendador-tarefa-component></agendador-tarefa-component>
    </div>
</template>
<script>
import AgendadorTarefaComponent from '../../components/Painel/AgendadorTarefaComponent.vue';

export default {
    components: {
        AgendadorTarefaComponent
    }
}
</script>

